import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from './service/auth.service';
import { ApiService } from './custom-services/ApiService';
import { DataService } from './service/data.service';
import { CommonUtilService } from './service/utils/common-utils';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  private readonly assessmentYearApiPath = '/filingservice/v3/api/assessment-year/get';

  constructor(private authService: AuthService,
    private router: Router,
    private jwtHelper: JwtHelperService,
    private apiService: ApiService,
    private dataService: DataService){}

  canActivate(): Observable<boolean> | boolean | UrlTree {
    const token = this.authService.getToken();

    if (!token || this.jwtHelper.isTokenExpired(token)) {
      localStorage.clear();
      return this.router.createUrlTree(['/auth/sign-in']);
    }

    if (localStorage.getItem('CURRENT_ASSESSMENT_YEAR')) {
      return true;
    }

    // The sign-in flow sets CURRENT_ASSESSMENT_YEAR before navigating here, but a direct
    // navigation/refresh into /user-panel skips that — resolve it here too, otherwise every
    // page's parallel bootstrap calls fire before it's known and go out with an empty
    // Assessment-Year header (see token-interceptor.service.ts).
    return this.apiService.get(environment.taxpayer_base_url + this.assessmentYearApiPath).pipe(
      map(res => {
        const currentAY = CommonUtilService.toNormalAssessmentYearFormat(res?.replyMessage?.AY);
        this.dataService.updateData('CURRENT_ASSESSMENT_YEAR', currentAY);
        localStorage.setItem('CURRENT_ASSESSMENT_YEAR', currentAY);
        return true;
      }),
      catchError(() => {
        localStorage.clear();
        this.router.navigate(["/auth/sign-in"]);
        return of(false);
      })
    );
  }

}
